var render = function render(){var _vm=this,_c=_vm._self._c;return _c('btn',{attrs:{"light":"","type":"secondary","header":"","icon":['far', !!this.$root.asideCompressed ? 'arrow-to-right' : 'arrow-to-left'],"action":_vm.toogleAside}})
}
var staticRenderFns = []

export { render, staticRenderFns }